<template>
    <div class="py-20 px-6 space-y-10">
      <div class="flex w-full justify-center items-center text-ihh-midnight-gray font-semibold text-4xl text-center tracking-wide">Brands</div>
      <div class="space-y-4">
         <!-- <div class="w-full justify-start items-start text-ihh-midnight-gray font-semibold text-2xl text-start">Herbs and Such</div> -->
         <!-- <div class="w-full justify-start items-start text-ihh-slate-gray text-lg text-start">Top quality natural products for pregnancy, birth, postpartum and breastfeeding. Tinctures, oils, dry herbs, vitamins and more.</div> -->
      </div>

      <ImageBrands />
      <FilteredSearch />

    </div>
</template>

<!-- Vue Component Script -->
<script>
  import FilteredSearch from './ihh-items/filtered-search.vue';
  import ImageBrands from './ihh-items/image-brands.vue';
  export default {
  components: { FilteredSearch, ImageBrands },
      data() {
         return {

         };
      },
      methods: {
      },
   };
</script>
